<style lang="scss" scoped type="text/scss">
  .count-down {
    font-size: 14px;
    //#689bf7
    color: #fff;
    background-color: #729cee;
    width: 102px;
    height: 30px;
    border: 1px solid #aac3f6;
    line-height: 30px;
    border-radius: 3px;
    text-align: center;
    cursor: pointer;
    position: absolute;
    top: 0;
  }
</style>
<template>
  <div
    class="count-down"
    :class="{'count-down-text-indent' : count}"
    @click="handleTouchend"
    ref="countDown"
  >
    <!--<div class="count-down-left"></div>-->
    {{count ? count: message}}
  </div>
</template>
<script>
  export default {
    props: {
      time: {
        type: Number,
        default: 60
      }
    },
    data() {
      return {
        message: '获取验证码',
        count: '',
        number: 0,
        flag: true
      }
    },
    methods: {
      counts(number) {
        number = this.count ? number : this.time;
        this.count = number + ' s';
        if(number > 0) {
          setTimeout(() => {
            this.counts(number)
          }, 1000);
        } else {
          this.flag = true;
          this.count = '';
          this.message = '重新获取'
        }
        number--;
      },
      countDown() {
        if(!this.flag) {
          return
        }
        this.flag = false;
        this.counts();
      },
      handleTouchend() {
        this.$emit('countDown', this.countDown);
      }
    },
    mounted() {
      this.$nextTick(() => {
        setTimeout(() => {
          let countDown = this.$refs.countDown;
          if(countDown && countDown.parentNode) {
            let w = countDown.parentNode.querySelector('input').offsetWidth;
            countDown.style.left = w + 8 + 'px';
          }
        })

      })

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/CountDown/index.vue